import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as DateHelpers from './DateHelpers';
import JobInfoData from './ScheduleNewJobInfoModal';
import JobScheduleVoidModalData from './JobScheduleVoidModal';
import { GetQuery, PostQuery } from './Shared';
import type { GenericList } from './models/JobSharedInterfaces';

interface SearchProps {
    statusOptions: GenericList[];
    showModal: boolean;
    hideModal(): void;
    view(dateSelected: string): void;
    updateScheduleDay(datesToUpdate: string[]): void;
}

interface SearchModal {
    jobIdSearch: string;
    siteAddressSearch: string;
    quoteNumberSearch: string;
    customerSearch: string;
    statusSearchId: number;
    showResults: boolean;
    results: SearchResults[];
    showJobInfo: boolean;
    showVoidGearList: boolean;
    scheduleId: number;
    jobQuoteItemId: number;
    scheduleIndex: number;
    errors: any;
}

interface SearchResults {
    itemIndex: number;
    selected: boolean;
    scheduleId: number;
    jobQuoteItemId: number;
    scheduleDate: string;           //yyyy-MM-dd
    scheduleDateFormatted: string;  //dd/MM-yyyy
    jobId: number;
    siteAddress: string;
    customer: string;
    item: string;
    itemId: number;
    itemShortcut: string;
    type: string;
    quantityType: string;
    hirePeriod: string;
    onoffhireDate: string;          //yyyy-MM-dd
    onoffhireDateFormatted: string; //dd/MM-yyyy
    callout: boolean;
    notes: string;
    status: string;
    allowEdit: boolean;
    isDirty: boolean;
}

export default class ScheduleNewSearchData extends React.Component<SearchProps, SearchModal> {
    constructor(props: SearchProps) {
        super(props);
        this.state = {
            jobIdSearch: "",
            siteAddressSearch: "",
            quoteNumberSearch: "",
            customerSearch: "",
            statusSearchId: -1,
            showResults: false,
            results: [],
            showJobInfo: false,
            showVoidGearList: false,
            scheduleId: -1,
            jobQuoteItemId: -1,
            scheduleIndex: -1,
            errors: {}
        }
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    onKeyUp = (e: any) => {
        //check if enter key has been pressed and if so call search
        if (e.keyCode === 13) {
            this.search(e);
        }
    }

    search = (e: any) => {
        e.preventDefault();

        if (!this.state.jobIdSearch && !this.state.siteAddressSearch && !this.state.quoteNumberSearch && !this.state.customerSearch) {
            toast.error("Please enter a Search criteria before searching!");
        } else {
            this.searchJobs();
        }
    }

    searchJobs = async () => {
        const apiUrl = "SearchScheduledJobs?JobId=" + this.state.jobIdSearch + '&SiteAddress=' + this.state.siteAddressSearch + '&QuoteNumber=' + this.state.quoteNumberSearch + '&Customer=' + this.state.customerSearch + '&StatusId=' + this.state.statusSearchId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                var items = result.data.items;
                for (var i = 0; i < items.length; i++) {
                    items[i].itemIndex = i;
                };
                this.setState({ showResults: true, results: items })
            }
        } 
    }

    selectItem = (e: any, index: number) => {
        var results = this.state.results;

        //uncheck all existing results as can only select one item
        for (var i = 0; i < results.length; i++) {
            results[i].selected = false;
        }

        var result = results[index];
        result.selected = e.target.checked;
        this.setState({ results: results });
    }

    onDateCellChange = (index: number, e: any) => {
        var results = this.state.results;
        var item = results[index];

        let newItem: any = {};
        newItem = item;
        newItem[e.target.name] = e.target.value;
        newItem.isDirty = true;

        this.setState({ results: results });
    }

    hideModal = () => {
        this.setState({ jobIdSearch: "", siteAddressSearch: "", quoteNumberSearch: "", customerSearch: "", statusSearchId: -1, showResults: false, results: [], errors: {} });
        this.props.hideModal();
    }

    //SHOW INFO
    showInfo = (e: any, index: number) => {
        e.preventDefault();

        var item = this.state.results[index];
        this.setState({ showJobInfo: true, scheduleId: item.scheduleId, scheduleIndex: index });
    }

    hideJobInfo = () => {
        this.setState({ showJobInfo: false, scheduleId: -1, jobQuoteItemId: -1, scheduleIndex: -1 });
    }

    openGearlist = () => {
        var item = this.state.results[this.state.scheduleIndex];
        this.setState({ showJobInfo: false, showVoidGearList: true, jobQuoteItemId: item.jobQuoteItemId });
    }

    saveJobInfo = () => {
        toast.success("Job Info Saved");
        this.setState({ showJobInfo: false, scheduleId: -1, jobQuoteItemId: -1, scheduleIndex: -1 });
        
    }
    //END SHOW INFO

    //VOID GEAR LIST
    hideVoidGearList = () => {
        this.setState({ showVoidGearList: false, showJobInfo: true, jobQuoteItemId: -1 });
    }

    saveVoidGearList = () => {
        this.setState({ showVoidGearList: false, showJobInfo: true, jobQuoteItemId: -1 });
    }
    //END VOID GEARLIST

    validate = () => {
        var items = this.state.results.filter(i => i.selected);
        if (items.length === 0) {
            toast.error("Please select at least one job to view");
            return false;
        }

        return true;
    }

    view = (e: any) => {
        e.preventDefault();
       
        //save selected job
        if (this.validate()) {
            var items = this.state.results.filter(i => i.selected);
            var scheduleDate = items[0].scheduleDate;
            //var scheduleId = items[0].scheduleId;
            this.setState({ jobIdSearch: "", siteAddressSearch: "", quoteNumberSearch: "", customerSearch: "", statusSearchId: -1, showResults: false, results: [], errors: {} });
            this.props.view(scheduleDate);
        }
    }

    validateSave = () => {
        let errors: any = {};
        let formIsValid = true;
        var items = this.state.results.filter(r => r.isDirty);

        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < items.length; i++) {
            var newErrorString = "";

            if (!DateHelpers.isValidDate(items[i].scheduleDate)) {
                newErrorString += " Valid Schedule Date, ";
                error = true;
            }

            if (!DateHelpers.isValidDate(items[i].onoffhireDate)) {
                newErrorString += " Valid On/Offhire Date, ";
                error = true;
            } else if (items[i].type == 'Install' && !DateHelpers.compareDate(items[i].scheduleDate, items[i].onoffhireDate)) {
                newErrorString += " Onhire Date >= Schedule Date, ";
                error = true;
            } else if (items[i].type == 'Pick Up' && !DateHelpers.compareDate(items[i].onoffhireDate, items[i].scheduleDate)) {
                newErrorString += " Offhire Date < Schedule Date, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + (items[i].itemIndex + 1) + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }
            
        }
        if (error) {
            formIsValid = false;
            errors["results"] = errorString;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validateSave()) {
            var results = this.state.results;
            var items = results.filter(r => r.isDirty);

            if (items.length > 0) {
                this.saveSearchItems();
            } else {
                toast.info("No items have been changed!");
            }
            

        } else {
            toast.error("Please fix validation errors before Saving");
        }

    }

    saveSearchItems = async () => {
        var results = this.state.results;
        var items = results.filter(r => r.isDirty);

        let saveSearch = {
            items: items
        };

        var jsonItem = JSON.stringify(saveSearch);

        const apiUrl = "SaveSearchItems";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                //reset is dirty flags
                for (var i = 0; i < results.length; i++) {
                    results[i].isDirty = false;
                }
                this.setState({ results: results })

                var datesToUpdate = result.data;
                this.props.updateScheduleDay(datesToUpdate);

                toast.success("Schedule Saved");
            }
        }
    }

    render() {
        let contents = this.renderDetails();

        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let minDate = DateHelpers.addDaysToCurrentDate(-7);
        let statusOptions = this.props.statusOptions;

        let jobInfo = <JobInfoData systemCompanyId={2} scheduleId={this.state.scheduleId} showModal={this.state.showJobInfo} hideModal={this.hideJobInfo} openGearlist={this.openGearlist} saveModal={this.saveJobInfo} />
        let editVoidGearlist = <JobScheduleVoidModalData showModal={this.state.showVoidGearList} jobQuoteItemId={this.state.jobQuoteItemId} hideModal={this.hideVoidGearList} saveModal={this.saveVoidGearList} />

        return (
            <div>
                <div className={this.state.showJobInfo ? "static-modal" : "hidden"}>
                    {jobInfo}
                    {editVoidGearlist}
                </div>
                <div className="static-modal">
                    <Modal size="xl" show={this.props.showModal} onHide={this.hideModal}>
                        <Modal.Header className="modal__header--colour">
                            <Modal.Title>Search Scheduled Jobs</Modal.Title>
                            <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="makeitflex">
                                <label className="input-group--inline" htmlFor="jobIdSearch">
                                    <span className="label">Job Id</span>
                                    <input className="input schedulenew__addSearch--width-sm" type="text" id="jobIdSearch" name="jobIdSearch" value={this.state.jobIdSearch} onChange={(e) => this.handleChange(e)} onKeyUp={(e) => this.onKeyUp(e)}></input>
                                </label>
                                <label className="input-group--inline" htmlFor="siteAddressSearch">
                                    <span className="label label--setsizesm">Site Address</span>
                                    <input className="input schedulenew__addSearch--width-lg" type="text" id="siteAddressSearch" name="siteAddressSearch" value={this.state.siteAddressSearch} onChange={(e) => this.handleChange(e)} onKeyUp={(e) => this.onKeyUp(e)}></input>
                                </label>
                                <label className="input-group--inline" htmlFor="quoteNumberSearch">
                                    <span className="label">Quote #</span>
                                    <input className="input schedulenew__addSearch--width-sm" type="text" id="quoteNumberSearch" name="quoteNumberSearch" value={this.state.quoteNumberSearch} onChange={(e) => this.handleChange(e)} onKeyUp={(e) => this.onKeyUp(e)}></input>
                                </label>
                                <label className="input-group--inline" htmlFor="customerSearch">
                                    <span className="label label--setsizesm">Customer</span>
                                    <input className="input schedulenew__addSearch--width-lg" type="text" id="customerSearch" name="customerSearch" value={this.state.customerSearch} onChange={(e) => this.handleChange(e)} onKeyUp={(e) => this.onKeyUp(e)}></input>
                                </label>
                                <label className="input-group--inline" htmlFor="statusSearchId">
                                    <span className="label label--setsizesm">Status</span>
                                    <select className="select" id="statusSearchId" name="statusSearchId" value={this.state.statusSearchId} onChange={(e) => this.handleChange(e)}>
                                        <option defaultValue="-1" value={-1}></option>
                                        {statusOptions.map(status =>
                                            <option key={status.id} value={status.id}>{status.name}</option>
                                        )};
                                    </select>
                                </label>
                            </div>
                            <div className="marginBottom10">
                                <button className="defaultbutton defaultbutton__small allocate__searchMargin" type='button' onClick={(e) => this.search(e)}>Search</button>
                            </div>
                            <div className={this.state.showResults ? "" : "hidden"}>
                                <div className={this.state.results.length > 0 ? 'overflowAuto schedulenew__result--height' : 'hidden'}>
                                    <table className='table tableColours-header'>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>Date</th>
                                                <th>On/Off Hire</th>
                                                <th>Job Id</th>
                                                <th>Site Address</th>
                                                <th>Customer</th>
                                                <th>Item</th>
                                                <th>Status</th>
                                                <th>Quantity</th>
                                                <th>Hire Period</th>
                                                <th>Notes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.results.map((result, index) =>
                                                <tr key={index} className={result.type === "Install" ? "tableColours--install" : "tableColours--pickup"}>
                                                    <td>{result.itemIndex + 1}</td>
                                                    <td>
                                                        <a href="#" onClick={(e) => this.showInfo(e, index)}>
                                                            <span className="fas fa-info-circle copy--icon alignIconCenter tooltipitem tooltipitem__right"><span className="tooltipitemtext tooltipitemtext__right">Booking Information</span></span>
                                                        </a>
                                                    </td>
                                                    <td><input type='checkbox' className="input" checked={result.selected} onChange={(e) => this.selectItem(e, index)} /></td>
                                                    <td>
                                                        <input type='date' min={minDate} id="scheduleDate" name="scheduleDate" className={result.allowEdit ? "form-control allocate__dateSize" : "hidden"} value={result.scheduleDate} onChange={(e) => this.onDateCellChange(index, e)} />
                                                        {result.allowEdit ? "" : result.scheduleDateFormatted}
                                                    </td>
                                                    <td>
                                                        <input type='date' min={minDate} id="onoffhireDate" name="onoffhireDate" className={result.allowEdit ? "form-control allocate__dateSize" : "hidden"} value={result.onoffhireDate} onChange={(e) => this.onDateCellChange(index, e)} />
                                                        {result.allowEdit ? "" : result.onoffhireDateFormatted}
                                                    </td>
                                                    <td>
                                                        <Link to={'/job/' + result.jobId + '/details'} target="_blank" >
                                                            {result.jobId}
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <div className="tooltipitem  tooltipitem__right">{result.siteAddress ? result.siteAddress.substring(0, 30) + "... " : ""}
                                                            <span className="tooltipitemtext  tooltipitemtext__right">{result.siteAddress}</span>
                                                        </div>
                                                    </td>
                                                    <td>{result.customer}</td>
                                                    <td>
                                                        <div className="tooltipitem tooltipitem__right">{result.itemShortcut}
                                                            <span className="tooltipitemtext tooltipitemtext__right">{result.item}</span>
                                                        </div>
                                                    </td>
                                                    <td>{result.status}</td>
                                                    <td>{result.quantityType}</td>
                                                    <td>{result.hirePeriod}</td>
                                                    <td>
                                                        <div className="tooltipitem  tooltipitem__left">{result.notes ? result.notes.substring(0, 20) + "... " : ""}
                                                            <span className="tooltipitemtext  tooltipitemtext__left">{result.notes}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {this.state.errors["results"] ?
                                    (this.state.errors["results"]).split("\n").map((item: any, key: any) => {
                                        return <span className="label errors" key={key}>{item}<br /></span>
                                    })
                                    : ""}
                                <span className={this.state.results.length == 0 ? "" : "hidden"}>There were no matching jobs found. Try modifying your search criteria.</span>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="popup-button--yes" onClick={this.save}>Save</button>
                            <button className="popup-button--yes marginLeft10" onClick={this.view}>View</button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}